export const formatValue = (amount, unit = " Mi") => {
    return (amount / 1000000).toFixed(2) + unit;
}
